import './App.css';

import { useCallback, useState } from 'react';
import ElectrochemicalDepositionForm from './components/electrochemical-deposition';
import ArIonMillingForm from './components/ar-ion-milling';
import ElectroPolishingForm from './components/electropolishing';
import FTIRForm from './components/ftir';
import HardnessTestForm from './components/hardness-test';
import MetallurgicalGrindPolishingForm from './components/metallurgical-grind-polishing';
import SampleImbeddingForm from './components/sample-imbedding-form';
import ScXrdForm from './components/sc-xrd';
import SemEbsdForm from './components/sem-ebsd';
import SemEdsForm from './components/sem-eds';
import SemMorphologyForm from './components/sem-morphology';
import SurfaceAreaForm from './components/surface-area';
import UVVusNirForm from './components/uv-vis-nir';
import XRayReflectometerForm from './components/x-ray-reflectometer';

const App = () => {
  console.log("www", window.location.href);
  const query = window.location.href.split('?query=')[1] || 'electrochemical-deposition';

  return (
    <div className='root'>
      <div className='wrapper'>
        {
          query === 'electrochemical-deposition' &&
            <ElectrochemicalDepositionForm />
        }
        {
          query === 'ar-ion-milling' &&
            <ArIonMillingForm />
        }
        {
          query === 'electropolishing' &&
            <ElectroPolishingForm />
        }
        {
          query === 'ftir' &&
            <FTIRForm />
        }
        {
          query === 'hardness-test' &&
            <HardnessTestForm />
        }
        {
          query === 'metallurgical-grind-polishing' &&
            <MetallurgicalGrindPolishingForm />
        }
        {
          query === 'sample-imbedding-form' &&
            <SampleImbeddingForm />
        }
        {
          query === 'sc-xrd' &&
            <ScXrdForm/>
        }
        {
          query === 'sem-ebsd' &&
            <SemEbsdForm/>
        }
        {
          query === 'sem-eds' &&
            <SemEdsForm/>
        }
        {
          query === 'sem-morphology' &&
            <SemMorphologyForm />
        }
        {
          query === 'surface-area' &&
            <SurfaceAreaForm />
        }
        {
          query === 'uv-vis-nir' &&
            <UVVusNirForm />
        }
        {
          query === 'x-ray-reflectometer' &&
            <XRayReflectometerForm />
        }
      </div>
    </div>
  );
};


export default App;